import {
  applyWrapTemplate,
  expressionWrapTemplate,
  functionWrapTemplate,
} from "@/input/utils/wrapTemplate";

import type { KeyboardInputAction } from "@/input/types";
import type { WrapTemplate } from "@/input/utils/wrapTemplate";

const WRAP_TEMPLATES: Record<string, WrapTemplate | undefined> = {
  "∑": functionWrapTemplate("function-summation"),
  "∫": expressionWrapTemplate("Integral"),
};

const wrapShortcuts: Partial<Record<string, KeyboardInputAction>> = {};

for (const [symbol, template] of Object.entries(WRAP_TEMPLATES)) {
  wrapShortcuts[symbol] = {
    action: (doc) => {
      if (!template || !doc.selection.hasSelectedNodes || !doc.selection.isContinuousSelection) {
        return false;
      }

      return applyWrapTemplate(doc, template, doc.selection.selectedNodes);
    },
  };
}

export { wrapShortcuts };
